import React, { useState } from 'react';
import * as PropTypes from 'prop-types';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { textToLinks } from 'utils/text-to-links';

export const CommentRow = (props) => {
  const { comment, isNew, isOwner } = props;
  const [isBlocked, setIsBlocked] = useState(false);
  const commentContent = textToLinks(comment.content);
  const { t } = useTranslation();

  const deleteHandler = (id) => {
    setIsBlocked(true);
    props.onDelete(id);
  };

  return (
    <div className={`e-item ${isBlocked && 'e-item-is-blocked'}`} data-e2e="comment">
      {comment.user && <span className="e-name">{comment.user.name || comment.user.email}</span>}
      <span className="e-date">{format(comment.createdAt * 1000, `${t('formats:datetime')} - H:mm`)}</span>
      {isOwner && (
        <span className="e-delete" data-e2e="deleteComment" onClick={() => deleteHandler(comment.id)}>
          {t('delete')}
        </span>
      )}
      {isNew && (
        <span className="e-newest">
          <FontAwesomeIcon icon={faCircle} />
          {t('newest_comment')}
        </span>
      )}
      <span className="e-comment">{commentContent}</span>
    </div>
  );
};

CommentRow.propTypes = {
  comment: PropTypes.object.isRequired,
  onDelete: PropTypes.func.isRequired,
  isNew: PropTypes.bool,
  isOwner: PropTypes.bool.isRequired,
};
